import { render, staticRenderFns } from "./PickUp.vue?vue&type=template&id=97097d40&scoped=true&"
import script from "./PickUp.vue?vue&type=script&lang=js&"
export * from "./PickUp.vue?vue&type=script&lang=js&"
import style0 from "./PickUp.vue?vue&type=style&index=0&id=97097d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97097d40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
